import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography, } from '@mui/material';
import React, { useEffect, useState } from 'react';
// import { faqs } from "./acceleratedCashbackData";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ctaImage from '../../pages/mystery-box/images/bg-top.png';
import Heading from '../../pages/mystery-box/images/top-heading.png';
import Unlock from '../../pages/mystery-box/images/unlock.png';
import Bg from '../../pages/mystery-box/images/state-bg.png';
import BgImage from '../../pages/mystery-box/images/bg.png';
import Bonus from '../../pages/mystery-box/images/bonus.png';
import Gradiant from '../../pages/mystery-box/images/Gradient.png';
import ReactHtmlParser from 'html-react-parser';
import Mystery from '../../pages/mystery-box/images/image.png';
import Line from '../../pages/mystery-box/images/Line.png';
import BgtopImage from '../../pages/mystery-box/images/bgimage.png';
import Cta from '../../pages/mystery-box/images/CTA.png';
import Earn from '../../pages/mystery-box/images/earn.png';
import AJio from '../../pages/mystery-box/images/AJio.png';
import Flipkart from '../../pages/mystery-box/images/Flipkart.png';
import Myntra from '../../pages/mystery-box/images/Myntra.png';
import MamaEarth from '../../pages/mystery-box/images/MMEARTH.png';
import XYXX from '../../pages/mystery-box/images/XYXX.png';
import Shopsy from '../../pages/mystery-box/images/Shopsy.png';
import Amazon from '../../pages/mystery-box/images/amazon.png';
import Truemeds from '../../pages/mystery-box/images/Truemeds.png';
import Strch from '../../pages/mystery-box-jan/images/strch.png';
import Fitspire from '../../pages/mystery-box-jan/images/fitspire.png';
import Kopara from '../../pages/mystery-box-jan/images/kopara.png';
import Derma from '../../pages/mystery-box/images/Derma.png';
import Arrow from '../../pages/mystery-box/images/arrow.png';
import Bellavita from '../../pages/mystery-box-jan/images/bellavitta.png';
import { useNavigate } from 'react-router-dom';
import dor from './images/dor.png'
import Foxtale from './images/foxtale.png'
import Boat from './images/boat.png'
import Puer from './images/puer.png'
import Levis from './images/levis.png'
import Booking from './images/booking.png'
import spencer from './images/spencer.png'
import bellavita from './images/bellavita.png'





const faqs = [
  {
    question: "What is the Mystery Gift Box?",
    answer: "The Mystery Gift Box is a special offer where you can unlock a Bonus Cashback of up to ₹500 on your next transaction till 31st January 2026."
  },
  {
    question: "How do I unlock & claim my Mystery Bonus? ",
    answer:  "To unlock the Mystery Bonus, you must first register and then shop from an eligible retailer that offers Cashback / Rewards.  When you complete the transaction, wait 24 - 48 hours after it is tracked and reflected in “My Earnings” section on the CashKaro app. Once updated, your Mystery Bonus will unlock and can be claimed by tapping the gift box on this offer landing page. "
  },
  {
    question: "Can I unlock the Bonus on any transaction? ",
    answer: "This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback/ Rewards are unavailable. Any other successful transaction within the offer period will make you eligible to unlock the Bonus."
  },
  {
    question: "Can I claim the Bonus more than once in a month? ",
    answer: "No, each user is eligible for only one Mystery Bonus per month."
  },
  {
    question: "What happens if I cancel my transaction after unlocking the Bonus? ",
    answer: "If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed. However, you can still make another valid transaction within the offer period to confirm and claim your Bonus. "  
  },
  {
    question: "How long does it take for my Bonus to be credited? ",
    answer: "The Bonus amount will be added to your CashKaro account within 48 – 72 hours of claiming. It will appear in Pending state in “My Earnings” section on your CashKaro app/ website. The Bonus will be confirmed and credited within 10 days after the transaction linked to it is Confirmed and Validated."
  },
  {
    question: "Can my Bonus be changed or canceled? ",
    answer: "Once the Bonus is unlocked and claimed, it cannot be altered. However, if your qualifying transaction is canceled or invalid, and no other valid transaction is made during the offer period, the Bonus will be cancelled."
  }
];
const Terms = [
  {
    question: "Eligibility Criteria",
    answer: `<ul>
    <li>This offer is valid only for users who have received official communication from CashKaro about it.</li>
    <li>Each user is eligible for only one Mystery Bonus per month.</li>
  </ul>`},
  {
    question: "Bonus Unlock & Tracking Process",
    answer: `<ul>
    <li>To unlock the Mystery Bonus, users must first register and then shop from an eligible retailer that offers Cashback / Rewards.</li>
    <li>Upon completing the transaction, users must wait 24 - 48 hours after it is added and reflected in the "My Earnings" section before their Mystery Bonus unlocks and can be claimed.</li>
    <li>The unlocked Mystery Bonus will be available for claiming on the offer landing page.</li>
    <li>The Bonus amount will be added to the user’s CashKaro account within 48 - 72 hours after the claim.</li>
    <li>It will be reflected in pending state in the “My Earnings” section of the user's account on the CashKaro app or website.</li>
    <li>The Bonus will be confirmed and credited within 10 days after the transaction linked to it is Confirmed and Validated.</li>
    <li>This offer does not apply to transactions from Amazon Recharge, Swiggy, and other stores where Cashback is unavailable.</li>

  </ul>`},
  {
    question: "Bonus Amount Allocation",
    answer: `<ul>
    <li>The Bonus is randomly assigned and can be up to ₹500. The assigned amount is final and cannot be changed or influenced.</li>
    <li>Only transactions made within the offer period will be eligible to unlock the Mystery Bonus.</li>
  </ul>`},
  {
    question: "Disqualification Criteria",
    answer: `<ul>
    <li>If the qualifying transaction is returned, canceled, or violates the offer T&C, the Mystery Bonus unlocked through that transaction will not be confirmed.</li>
    <li>However, the user can still complete another valid transaction within the offer period to confirm and claim their Bonus.</li>
    <li>CashKaro reserves the right to revoke the Bonus if fraudulent activity, misuse, or policy violations are detected.</li>
  </ul>`},
  {
    question: "Modification & Termination",
    answer: `<ul>
    <li>Changes to the terms, eligibility, or Bonus structure will be communicated at CashKaro’s discretion.</li>
  </ul>`},
  {
    question: "General Terms",
    answer: `<ul>
    <li>Participation in this offer constitutes acceptance of these terms and conditions. CashKaro’s decision regarding all aspects of the offer will be final and binding.</li>
  </ul>`},
];


export default function MysteryBoxBonusNov() {

  const [alertOpen, setAlertOpen] = useState(true);
  const [message, setMessage] = useState();
  const [transaction, setTransaction] = useState(1);
  const [Reveal, setReveal] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const bonus = localStorage.getItem('mb_bonus_jan') || 0
  const bonus_added = localStorage.getItem('mb_bonus_added_jan') || 0
  const navigate = useNavigate()

  let checkFunction = async () => {
    let ck_id_check = localStorage.getItem('mb_ck_id_jan')
 
    try {
      if(ck_id_check){
        let response = await fetch(`${process.env.REACT_APP_SITE_URL_VP}/api/user/getuserdata_mb_jan?ck_id=${ck_id_check}`)
        response = await response.json()
        console.log(response.user_data)
        localStorage.setItem('mb_bonus_jan',response?.user_data?.bonus)
        localStorage.setItem('mb_bonus_added_jan',response?.user_data?.bonus_added)
        localStorage.setItem('mb_open_jan',response?.user_data?.claim)
        if(response?.user_data?.claim != 1){
          navigate('/mystery-box-jan/index',{replace:true})
        }
       
      }else{
        navigate('/mystery-box-jan/index',{replace:true})
      }
      
    } catch (error) {
      console.log(error.message)
    }
  
  }
  
  useEffect(()=>{
    checkFunction()
  },[])

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  const handleImageClick = () => {
    setReveal(true);
  };

  const showAlert = () => {
    setAlertOpen(true);
  };

  const closeAlert = () => {
    setAlertOpen(false);
  };
  return (
    <Grid container >
      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>
      <Grid item xs={12} sm={12} md={4} lg={4}
        sx={{
          backgroundImage: `url(${BgImage})`,
          // minHeight: '100%'
        }}>
        <Box sx={{
          position: 'relative', width: '100%',
        }}>
          <Box>
            <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '60px' }}>
              <img src={Mystery} alt="Mystery" style={{ width: '212px' }} />
            </div>
            <div
              style={{
                marginTop: '1rem',
                display: 'flex',
                flexDirection: 'column', // Stacks children vertically
                alignItems: 'center',    // Centers items horizontally
                borderTopLeftRadius: '15px',
                borderTopRightRadius: '15px',
                backgroundImage: `url(${Gradiant})`,
                marginLeft: '1rem',
                marginRight: '1rem'
              }}
            >
              {/* <img src={Heading} alt="heading" style={{ width: '100%' }} /> */}
              <Typography py={2} sx={{ textAlign: 'center', fontFamily: 'DM Sans', fontWeight: '900', fontSize: '24px', lineHeight: '28.8px', color: '#fff' }}>You got ₹{bonus}</Typography>
              <img src={Line} alt='line' style={{ width: '35%', }} />
              <Typography pt={1} pb={2} sx={{ textAlign: 'center', fontFamily: 'DM Sans', fontWeight: '600', fontSize: '12px', lineHeight: '14.4px', color: '#fff' }}>{bonus_added == 1 ? "This Bonus Cashback has been added" : "You have claimed your Bonus Cashback"}</Typography>
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column', // Stacks children vertically
                alignItems: 'center',    // Centers items horizontally
                borderBottomLeftRadius: '15px',
                borderBottomRightRadius: '15px',
                backgroundImage: `url(${BgtopImage})`,
                marginLeft: '1rem',
                marginRight: '1rem',
              }}
            >
              {/* <img src={Heading} alt="heading" style={{ width: '100%' }} /> */}
              <Typography pt={1.4} pb={1.4} sx={{ textAlign: 'center', fontFamily: 'DM Sans', fontWeight: '600', fontSize: '12px', lineHeight: '14.4px', color: '#fff' }}>{bonus_added == 1 ? "Your Bonus will be confirmed within 10 days after the transaction linked to it is confirmed & validated*" : `It may take up to 72 hours for your bonus to reflect in your "My Order Details" section.`}</Typography>
            </div>

            <div style={{
              display: 'flex',
              justifyContent: 'center',
            }}>

         <a href='cashkaro://my-earnings'>
         <img
                src={Cta}
                alt="Cta"
                style={{ width: '231px', paddingTop: '24px' }}
                // onClick={()=>window.location.href='https://cashkaro.com/my-earnings'}
              // onClick={showAlert}
              />
         </a>
            </div>
            <div style={{
              display: 'flex',
              justifyContent: 'center',

              // alignItems: 'center', // Ensures vertical alignment if needed
            }}>

              <img
                src={Earn}
                alt="Earn"
                style={{ width: '287px', paddingTop: '48px' }}
              // onClick={showAlert}
              />
            </div>
            <Grid container mt={3}>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/strch-coupons'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src={Strch}
                      alt="Strch"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                    Strch 
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                    Flat <br/>
                    75% Cashback
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/fitspire-coupons'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src={Fitspire}
                      alt="Fitspire"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                   Fitspire 
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                    Flat <br/>20% Cashback
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/mama-earth-coupons'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src={MamaEarth}
                      alt="Flipkart"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                    MamaEarth
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                    Flat<br/> 18% Cashback
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container mt={2}>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/bella-vita-coupons'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src={Bellavita}
                      alt="Bellavita"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                    Bellavita
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                    Flat <br/>18% Cashback
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/cleevo-offers'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src="https://d2sriifpjiqv0p.cloudfront.net/free-money/cleevo.png"
                      alt="shopsy"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                    Cleevo
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                   Flat<br/> 30% Cashback
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={4} md={4} >
                <a href='cashkaro://stores/koparoclean-coupons'>
                  <Box
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    position="relative"
                  >
                    <img
                      loading="lazy"
                      src={Kopara}
                      alt="Kopara"
                      style={{ height: "68px" }}
                    />
                  </Box>
                  <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                </a>
                <Box sx={{ textAlign: "center" }}>
                  <Typography
                    sx={{
                      textAlign: "center",
                      color: "#fff",
                      fontSize: "12px",
                      fontWeight: 600,
                      marginTop: "18px",
                    }}
                  >
                    Koparo 
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      fontFamily: "Metropolis",
                      fontWeight: "600",
                      color: "#fff",
                      textAlign: "center",
                      display: "flex",
                      gap: "2px",
                      marginTop: "8px",
                      justifyContent: "center",
                    }}
                  >
                   Flat<br/> 40% Cashback
                  </Typography>
                </Box>
              </Grid>
            </Grid>
            <Grid container mt={2} mb={5}>
                <Grid item xs={4} md={4} >
                  <a href="cashkaro://stores/thedermaco-coupons">
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      position="relative"
                    >
                      <img
                        loading="lazy"
                        src={Derma}
                        alt="Derma"
                        style={{ height: '68px' }}
                      />
                    </Box>
                    <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                  </a>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        textAlign: 'center',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600,
                        marginTop: '18px',
                      }}
                    >
                      The Derma Co
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Metropolis',
                        fontWeight: '600',
                        color: '#fff',
                        textAlign: 'center',
                        display: 'flex',
                        gap: '2px',
                        marginTop: '8px',
                        justifyContent: 'center',
                      }}
                    >
                      Up to<br/> 20% Cashback
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} md={4}>
                  <a href="cashkaro://stores/foxtale-coupons">
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      position="relative"
                    >
                      <img
                        loading="lazy"
                        src={Foxtale}
                        alt="MamaEarth"
                        style={{ height: '68px' }}
                      />
                    </Box>
                    <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                  </a>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        textAlign: 'center',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600,
                        marginTop: '18px',
                      }}
                    >
                      Foxtale
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Metropolis',
                        fontWeight: '600',
                        color: '#fff',
                        textAlign: 'center',
                        display: 'flex',
                        gap: '2px',
                        marginTop: '8px',
                        justifyContent: 'center',
                      }}
                    >
                      Up to<br/> 15% Cashback
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={4} md={4}>
                  <a href="cashkaro://stores/xyxx-discount-code">
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      position="relative"
                    >
                      <img
                        loading="lazy"
                        src={XYXX}
                        alt="XYXX Crew"
                        style={{ height: '68px' }}
                      />
                    </Box>
                    <Box sx={{ textAlign: "center", marginTop:'-7%',zIndex:'99999',position:'relative' }}>
                  <img
                      loading="lazy"
                      src={Arrow}
                      alt="arrow"
                      style={{ height: "24px" }}
                    />
                  
                </Box>
                  </a>
                  <Box sx={{ textAlign: 'center' }}>
                    <Typography
                      sx={{
                        textAlign: 'center',
                        color: '#fff',
                        fontSize: '12px',
                        fontWeight: 600,
                        marginTop: '18px',
                      }}
                    >
                      XYXX Crew
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: '12px',
                        fontFamily: 'Metropolis',
                        fontWeight: '600',
                        color: '#fff',
                        textAlign: 'center',
                        display: 'flex',
                        gap: '2px',
                        marginTop: '8px',
                        justifyContent: 'center',
                      }}
                    >
                      Flat<br/> 7% Cashback
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            {/* {!showGrid && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  overflow: 'auto',
                }}
              >
                <a href='cashkaro://home'>
                <img
                  src={ViewMore}
                  alt="ViewMore"
                  style={{ width: '120px', paddingTop: '24px', cursor: 'pointer' }}
                  onClick={() => window.location.href='http://cashkaro.com'} // Show grid on click
                />
                </a>
              </div>
            )} */}
            {/* Render the grid when showGrid is true */}
         

            {/* <div style={{
              display: 'flex',
              justifyContent: 'center',
              bottom: '0',
              background: 'linear-gradient(180deg, rgba(59, 156, 190, 0) 0%, #1D4563 92.09%)',
              width: '100%',
              position: 'fixed',
              zIndex: '9999999',
              // alignItems: 'center', // Ensures vertical alignment if needed
            }}>

              <img
                src={Bonus}
                alt="Bonus"
                style={{ width: '100%' }}
              // onClick={showAlert}
              />
            </div> */}
          </Box>

          {/* Overlay Content */}
        </Box>

           {/* <Box sx={{display:'flex',justifyContent:'center',marginTop:'50px'}}>
                  <img src={dor} style={{height:'121px',width:'328px'}} />
                  </Box> */}

        <Box sx={{ paddingX: '18px' }}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '5px', marginTop: '24px' }}>FAQs</Typography>
          {faqs.map((faq, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "#355974",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'DM Sans'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#FFEEC3', }}>
                  {faq?.question}
                </AccordionSummary>
                <AccordionDetails>{faq?.answer}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        <Box sx={{ paddingX: '18px' }} pb={5}>
          <Typography sx={{ textAlign: 'center', paddingTop: '16px', fontFamily: "DM Sans", marginBottom: '16px', color: '#fff', fontSize: '12px', fontWeight: 600, lineHeight: '16px', letterSpacing: '3px' }}>TERMS & CONDITIONS</Typography>
          {Terms.map((Terms, i) => (
            <Box
              sx={{
                marginBottom: "16px",
                padding: "2px",
                background:
                  "linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0) 100%);",
                borderRadius: "14px",
              }}
            >
              <Accordion
                sx={{
                  borderRadius: "14px !important",
                  background: "#355974",
                  color: "#fff",
                  fontSize: "14px",
                  fontWeight: 600,
                  fontFamily: 'DM Sans'
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: "#fff" }} />}
                  sx={{ color: '#FFEEC3', }}>
                  {Terms?.question}
                </AccordionSummary>
                <AccordionDetails>{ReactHtmlParser(Terms?.answer)}</AccordionDetails>
              </Accordion>
            </Box>))}
        </Box>
        {/* <Alert open={alertOpen} type="success" message={message} setOpen={setAlertOpen} /> */}
      </Grid>

      <Grid item xs={12} sm={12} md={4} lg={4}></Grid>

    </Grid>
  );
}
